import { Typography } from "@mui/material"

/**
 * One thing a task's assignment overrides or ignores, in the tooltip beside its route in the
 * schedule drawer. Inherits the tooltip's colour, so it reads on its dark background.
 */
export function RoutingOverrideLine({ text }) {
    return (
        <Typography variant="caption" color="inherit" data-cy="schedule-task-override">
            {text}
        </Typography>
    )
}
